import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('auth', 'logout', ['CLEAR', 'EXPIRED_ERROR']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users/sessions',
  type: 'delete',
});

const defaultRequestReducer = createReqReducer(consts);

export default function(state, action) {
  switch (action.type) {
    case consts.EXPIRED_ERROR: {
      return { ...state, error: action.payload };
    }

    default:
      return defaultRequestReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/logout.js